"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var types_1 = require("@wix/social-groups-api/dist/src/types");
var social_groups_api_1 = require("@wix/social-groups-api");
var BaseGroupsController_1 = require("../common/BaseGroupsController");
var tpa_settings_1 = require("@wix/tpa-settings");
var widgetSettings_1 = require("../../settings/widgetSettings");
var settings_1 = require("../../settings");
var GroupsController = /** @class */ (function (_super) {
    tslib_1.__extends(GroupsController, _super);
    function GroupsController(controllerConfig, experiments) {
        if (experiments === void 0) { experiments = {}; }
        return _super.call(this, controllerConfig, experiments) || this;
    }
    GroupsController.prototype.getGroups = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var req;
            return tslib_1.__generator(this, function (_a) {
                req = this.getRequestFromConfig(config);
                return [2 /*return*/, this.groupListModel.listGroups(req)];
            });
        });
    };
    GroupsController.prototype.getRequestFromConfig = function (config) {
        var reqBuilder = new social_groups_api_1.GroupsRequestBuilder();
        var sortBy = this.getSortBy(config);
        var order = sortBy === social_groups_api_1.GroupsRequestSort.NAME
            ? types_1.CommonTypes.SortOrder.ASC
            : types_1.CommonTypes.SortOrder.DESC;
        var req = reqBuilder
            .addPaging(this.getLimit(config))
            .addSort(sortBy, order)
            .addFilter({
            approval_status: {
                $ne: 'PENDING',
            },
        })
            .build();
        return req;
    };
    GroupsController.prototype.getLimit = function (config) {
        var numberGroups = this.getLayoutSettings(config).numberGroups;
        return numberGroups;
    };
    GroupsController.prototype.getInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groups;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGroups(this.config)];
                    case 1:
                        groups = _a.sent();
                        this.cacheGroups(groups);
                        return [2 /*return*/, { groups: groups }];
                }
            });
        });
    };
    GroupsController.prototype.getLayoutSettings = function (config) {
        var layout = tpa_settings_1.getSettingsValues(config.publicData.COMPONENT || {}, widgetSettings_1.widgetLayoutSettings);
        return layout;
    };
    GroupsController.prototype.getSettingsSettings = function (config) {
        var settingsValues = tpa_settings_1.getSettingsValues(config.publicData.COMPONENT || {}, settings_1.settingsSettings);
        return settingsValues;
    };
    GroupsController.prototype.getSortBy = function (config) {
        var sortBy = this.getSettingsSettings(config).sortBy;
        return sortBy;
    };
    return GroupsController;
}(BaseGroupsController_1.BaseGroupsController));
exports.default = GroupsController;
//# sourceMappingURL=GroupsController.js.map